const Theme = {
	horizontalMarginMobile: "15px",
	horizontalMarginDesktop: "100px",
	primaryColor: "#89068f",
	headerBackgroundColor: "#ffffff",
	bodyBackgroundColor: "linear-gradient(180deg, rgba(242, 234, 244, 0.33) 0%, rgba(216, 211, 218, 0.33) 100%)",
	botMessage: "#f8f8f8",
}

export default Theme;